import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import { site } from "@/config/site";
import { usePublicSession } from "@/features/public/hooks/PublicSessionContext";
import { cn } from "@/utils/cn";

type PublicPrimaryCtaProps = {
  className?: string;
  variant?: "button" | "nav";
};

export function PublicPrimaryCta({ className, variant = "button" }: PublicPrimaryCtaProps) {
  const session = usePublicSession();
  const styleClass = variant === "nav" ? "pub-site-nav-cta" : "pub-btn pub-btn-primary";

  if (session === "loading") {
    return (
      <span
        className={cn(styleClass, "pointer-events-none opacity-50", className)}
        aria-busy="true"
      >
        …
      </span>
    );
  }

  if (session === "authenticated") {
    return (
      <Link to={ROUTES.dashboard} className={cn(styleClass, className)}>
        Dashboard
      </Link>
    );
  }

  return (
    <a
      href={site.stripeMarketplaceUrl}
      target="_blank"
      rel="noreferrer"
      className={cn(styleClass, className)}
    >
      Install on Marketplace ↗
    </a>
  );
}
